/**
 * `KeyboardEvent.key` for Escape, spelled here rather than imported from `@efficiently/models`.
 *
 * That package is tagged `type:util`, so the import was legal — but it is the shared browser+server
 * models bundle, and pulling it in for one string made it a compile input of every app that renders
 * this library. `ui-kit-docs` was the first to try: its `tsconfig.app.json` has no node types, and
 * `ngc` stopped on `Buffer` and a row of missing `override` modifiers inside a package this library
 * has no business compiling.
 */
export const ESCAPE_KEY = 'Escape';
